import type { SVGProps } from "react";

/*
  Íconos locales del back-office. El UI kit compartido (@/components/ui/icons)
  no trae estos — variante local en el área admin, mismo estilo (stroke 24x24).
  NUNCA emojis.
*/

type IconProps = SVGProps<SVGSVGElement> & { size?: number };

function Base({ size = 22, children, ...props }: IconProps & { children: React.ReactNode }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      {children}
    </svg>
  );
}

export const IconBuilding = (p: IconProps) => (
  <Base {...p}>
    <rect x="4" y="3" width="12" height="18" rx="1.2" />
    <path d="M8 7h4M8 10.5h4M8 14h4M16 11h4v10h-4" />
    <path d="M9 21v-3h2v3" />
  </Base>
);

export const IconCheck = (p: IconProps) => (
  <Base {...p}>
    <path d="m4.5 12.5 5 5 10-11" />
  </Base>
);

export const IconX = (p: IconProps) => (
  <Base {...p}>
    <path d="m6 6 12 12M18 6 6 18" />
  </Base>
);

export const IconFlag = (p: IconProps) => (
  <Base {...p}>
    <path d="M5 21V4" />
    <path d="M5 4.5c1.6-1 3.4-1 5 0s3.4 1 5 0v9c-1.6 1-3.4 1-5 0s-3.4-1-5 0" />
  </Base>
);

export const IconPhoneCall = (p: IconProps) => (
  <Base {...p}>
    <path d="M6 3h3l1.5 4.5-2 1.5a11 11 0 0 0 5.5 5.5l1.5-2L20 14v3a2 2 0 0 1-2 2c-7.7 0-14-6.3-14-14a2 2 0 0 1 2-2Z" />
  </Base>
);

export const IconLock = (p: IconProps) => (
  <Base {...p}>
    <rect x="5" y="10.5" width="14" height="9.5" rx="1.5" />
    <path d="M8 10.5V8a4 4 0 0 1 8 0v2.5" />
  </Base>
);

export const IconBell = (p: IconProps) => (
  <Base {...p}>
    <path d="M6 10a6 6 0 0 1 12 0c0 4 1.5 5.5 2 6H4c.5-.5 2-2 2-6Z" />
    <path d="M9.5 19a2.5 2.5 0 0 0 5 0" />
  </Base>
);

export const IconFileText = (p: IconProps) => (
  <Base {...p}>
    <path d="M7 3h7l4 4v14H7Z" />
    <path d="M14 3v4h4M9.5 12h5M9.5 15.5h5" />
  </Base>
);
